import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-partnerSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			var slider = new Swiper (el.querySelector('.b-partnerSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				slideClass: 'b-partner',
				watchOverflow: false,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					1024: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					1380: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
			});
		});
	});
});